module.exports = __webpack_public_path__ + "img/danger.svg";